import { AvailableThemeKey } from './available-theme-keys.type';
import { availableThemes } from './available-themes.const';

export const isValidTheme = (theme: unknown): theme is AvailableThemeKey => {
  return typeof theme === 'string' && theme in availableThemes;
};
